import React, { useState } from 'react';
import styled from 'styled-components';
import LibrarySearch from './LibrarySearch';
import RecordingDetail from './RecordingDetail';
import DuplicateReview from './DuplicateReview';
import CorrectionsNeeded from './CorrectionsNeeded';
import LanguageConflicts from './LanguageConflicts';

function TrackLibrary() {
  const [tab, setTab] = useState('search'); // 'search' | 'duplicates' | 'corrections' | 'languages'
  const [selectedId, setSelectedId] = useState(null);

  return (
    <Wrap>
      <SubTabs>
        <SubTab active={tab === 'search'} onClick={() => setTab('search')}>All Tracks</SubTab>
        <SubTab active={tab === 'duplicates'} onClick={() => setTab('duplicates')}>Duplicate Review</SubTab>
        <SubTab active={tab === 'languages'} onClick={() => setTab('languages')}>Language Conflicts</SubTab>
        <SubTab active={tab === 'corrections'} onClick={() => setTab('corrections')}>Corrections Needed</SubTab>
      </SubTabs>

      {tab === 'search' && <LibrarySearch onSelect={setSelectedId} />}
      {tab === 'duplicates' && <DuplicateReview />}
      {tab === 'languages' && <LanguageConflicts />}
      {tab === 'corrections' && <CorrectionsNeeded />}

      {selectedId && (
        <>
          <Backdrop onClick={() => setSelectedId(null)} />
          <Drawer>
            <RecordingDetail id={selectedId} onBack={() => setSelectedId(null)} />
          </Drawer>
        </>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 28px 32px 60px;
`;

const SubTabs = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border);
`;

const SubTab = styled.button`
  background: none;
  color: ${p => p.active ? 'var(--text)' : 'var(--text-3)'};
  font-size: 13px;
  font-weight: 500;
  padding: 0 2px 10px;
  margin-right: 20px;
  border-bottom: 2px solid ${p => p.active ? 'var(--accent)' : 'transparent'};
  transition: color 0.12s, border-color 0.12s;
  &:hover {
    color: var(--text);
  }
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 200;
  animation: fadeIn 0.15s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Drawer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(520px, 100vw);
  background: var(--bg-2);
  box-shadow: var(--shadow-lg);
  border-left: 1px solid var(--border);
  z-index: 201;
  overflow-y: auto;
  animation: slideIn 0.2s ease;

  @keyframes slideIn {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }

  @media (max-width: 480px) {
    width: 100vw;
  }
`;

export default TrackLibrary;
